import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.707 15.107a1 1 0 0 1-1.414 0l-4.8-4.8a1 1 0 1 1 1.414-1.414L12 12.986l4.093-4.093a1 1 0 1 1 1.414 1.414l-4.8 4.8Z"
  />,
  'ChevronDown'
)
